export default __webpack_public_path__ + "static/media/transfer.b2ad2f90.svg";